import React from "react";
import {getDisplayName, hoistNonReactStatics} from "@core-ui/utility";
import {useLocalize, UseLocalize} from "./useLocalize";

type WithLocalizeProps = UseLocalize;

export function withLocalize<
  Props extends WithLocalizeProps = WithLocalizeProps
>(
  Component: React.ComponentType<Props>
): React.ComponentType<Omit<Props, keyof WithLocalizeProps>> {
  function WithLocalize(
    props: Omit<Props, keyof WithLocalizeProps>
  ): JSX.Element {
    const localizeData = useLocalize();
    return <Component {...localizeData} {...props} />;
  }

  WithLocalize.displayName = `WithLocalize(${getDisplayName(Component)})`;
  return hoistNonReactStatics(WithLocalize, Component);
}
